import { Link } from '../../../components/ui/Link';
import type { Coupon, CouponGroup } from '../../coupon-management/versions/v1/fixtures';
import { relatedCoupons } from '../../coupon-management/versions/v1/stackRules';
import styles from './StackRangeCell.module.css';

export interface StackRangeCellProps {
  coupon: Coupon;
  entities: readonly Coupon[];
  groups: readonly CouponGroup[];
  /** 点击后查看这张券的叠加范围详情（推荐卡侧跳页、优惠券侧就地开抽屉）。 */
  onOpen: (couponId: number) => void;
}

/**
 * 「叠加范围」列的单元格：与优惠券列表同一形态——
 * 暂无时弱化色文字、有时数量用主题色，整格可点查看关系明细。
 */
export function StackRangeCell({ coupon, entities, groups, onOpen }: StackRangeCellProps) {
  const count = relatedCoupons(coupon.id, entities, groups).length;
  return count === 0
    ? <Link aria-label={`查看${coupon.name}的叠加范围`} muted onClick={() => onOpen(coupon.id)} type="default">暂无叠加范围</Link>
    : <Link aria-label={`查看可叠加的${count}张优惠券`} className={styles.relationLink} onClick={() => onOpen(coupon.id)} type="default">可与<span className={styles.relationCount}>{count}</span>张优惠券叠加</Link>;
}

/**
 * 二级表头下的紧凑形态：只给数量（正文色）或「暂无」（弱化色），
 * 两者悬停都转主题色，点击仍然查看明细；归属由表头的「老生券 / 新生券」表达。
 */
export function StackRangeValueCell({ coupon, entities, groups, onOpen }: StackRangeCellProps) {
  const count = relatedCoupons(coupon.id, entities, groups).length;
  return count > 0
    ? <Link aria-label={`查看${coupon.name}的叠加范围`} onClick={() => onOpen(coupon.id)} type="default">{count}</Link>
    /* muted：常态弱化色，悬停仍转所属语义（default→主题）色，与数量一致。 */
    : <Link aria-label={`查看${coupon.name}的叠加范围`} muted onClick={() => onOpen(coupon.id)} type="default">暂无</Link>;
}
